import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { ExportTimesheetPayload } from 'src/models/timesheet.model';

type InitialState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  userTimesheets: any;
};

const INITIAL_STATE: InitialState = {
  loading: false,
  success: false,
  failure: false,
  userTimesheets: null,
};

export const downloadUserTimesheet = createAsyncThunk(
  'download-user-timesheet/post',
  async (data: ExportTimesheetPayload, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await axios.post(`/api/user-timesheet/export`, data, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const filename = `Rapportino_${new Date(data.period).toLocaleDateString('it-IT', { year: 'numeric', month: 'long' })}.xlsx`;
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const userTimesheetDownloadSlice = createSlice({
  name: 'userTimesheetDownloadSlice',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(downloadUserTimesheet.pending, (state): InitialState => {
        return {
          ...state,
          loading: true,
          success: false,
          failure: false,
        };
      })
      .addCase(downloadUserTimesheet.fulfilled, (state): InitialState => {
        return {
          ...state,
          loading: false,
          success: true,
          failure: false,
        };
      })
      .addCase(downloadUserTimesheet.rejected, (state): InitialState => {
        return {
          ...state,
          loading: false,
          success: false,
          failure: true,
        };
      });
  },
});

export default userTimesheetDownloadSlice.reducer;
